<template>
       <section >
      <div class="container-fluid">
        <div class="w80">
          <div class="row" >
            <div :class="[ 'col-sm-12',{'col-md-5':item.media}]">
              <div class="row align-items-center">
                <div class="col-sm-12 center" >
                  <div class="inlineBlock">
                    <img :src="item.media" @error="replaceByDefault" class="post-image" v-if="item.media" />
                  </div>
                </div>
              </div>
              <div class="row actions align-items-center" v-if="item.media"  >
                    <div class="col">
                      <div class="button-container" >
                          <button :class="['accion-video',{'active':like}]" >
                              <svg
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    >
                                    <path
                                      d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 
                                      2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 
                                      2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                                    />
                              </svg>
                              <span></span>
                          </button>
                          <button :class="['accion-video',{'active':dislike}]">
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 
                                  2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 
                                  2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                              />
                            </svg>
                            <span></span>
                          </button>
                          <button :class="['accion-video',{'active':meh}]">
                            <svg fill="currentColor" aria-hidden="true" focusable="false" stroke="currentColor" data-prefix="fas" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg>                           
                            <span></span>
                          </button>
                      </div><!-- button-container -->
                    </div><!-- col -->
                    <div class="col-auto">
                      <div class="calificacion">
                        <div class="stars">
                          <label 
                            v-for="i in 4" 
                            :key="i"
                            :class="stars[i-1]" 
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
                              />
                            </svg>
                          </label>
                          </div><!-- stars -->
                      </div><!-- calificacion -->
                    </div><!-- col-auto -->
                  </div><!-- row actions align-items-center -->
            </div>
            <div :class="[ 'col-sm-12',{'col-md-7':item.media}]" >
              <div class="row align-items-center">
                  <div class="col">
                    <div class="user-avatar">
                      <div class="img-avatar" :style="{'background-image': 'url('+item.sourceImg+'),url('+defaultImage+')'}" ></div>
                      <div class="data-avatar">
                        <p class="user-name noticieroName touchpad">{{item.noticiero_nombre}}</p>
                        <p class="user"> <a class="verde" :href="item.link" target="_blank">@{{item.key_src}}</a></p>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                    <svg class="svgPD" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M20 6v12H4V6h16m2-2H2v14s0 2 2 2h16s2 0 2-2V4m-12 9H6V8h4v5m8 0h-7v-2h7v2m0-3h-7V8h7v2z" /></svg>
                  </div>
              </div><!-- row align-items-center -->
              <div class="post-info" >
                  <div class="info-heading">
                    <div class="row align-items-center">
                      <div class="col">
                        <h2 class="tiulo-post noMarginBottom">{{item.titulo}}</h2>
                      </div> <!-- col -->
                    </div> <!-- row align-items-center -->
                  </div><!--info-heading-->
                  <div class="content">
                      <p v-html="item.descripcion"></p>
                  </div><!-- content -->
                </div><!--post-info-->
                <div class="row actions align-items-center" >
                    <div class="col" v-if="!item.media">
                      <div class="button-container" >
                          <button :class="['accion-video',{'active':like}]">
                              <svg
                                fill="none"
                                viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    >
                                    <path
                                      d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 
                                      2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 
                                      2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                                    />
                              </svg>
                              <span></span>
                          </button>
                          <button :class="['accion-video',{'active':dislike}]">
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 
                                  2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 
                                  2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                              />
                            </svg>
                            <span></span>
                          </button>
                          <button :class="['accion-video',{'active':meh}]">
                           <svg fill="currentColor" aria-hidden="true" focusable="false" stroke="currentColor" data-prefix="fas" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg>
                            <span></span>
                          </button>
                      </div><!-- button-container -->
                    </div><!-- col -->
                    <div class="col-auto" v-if="!item.media">
                      <div class="calificacion">
                        <div class="stars">
                          <label 
                            v-for="i in 4" 
                            :key="i"
                            :class="stars[i-1]"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                            >
                              <path
                                d="M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"
                              />
                            </svg>
                          </label>
                          </div><!-- stars -->
                      </div><!-- calificacion -->
                    </div><!-- col-auto -->
                  </div><!-- row actions align-items-center -->
              </div><!-- col-sm-12-->
            </div><!-- row -->
            
            <br>
            <div class="keywords center">
                    <div class="chip iconed" v-for="(keyword,index) in item.keywords" :key="index">
                      {{keyword}}
                    </div>
                  </div>
            <div class="divider"></div>
            <div class="comentarios">
                <h2>Comentarios</h2>
                <div class="row">
                  <div class="col-sm-12 col-md-6"  v-if="comments.length>0">
                    <div class="noPadding noMargin" style="width:100%" v-for="(comment,index) in comments" :key="comment.key">
                        
                        <div class="inlineBlock noPadding noMargin" style="width:95%;"> 
                            <div v-html="convertString(comment.comentario)"></div>
                            <label class="sub">{{getFecha(comment.created)}}</label>
                        </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6"></div>
                  <div class="col-sm-12 col-md-6" >
                    <div class="button-circle-more secondary" v-if="LastEvaluatedKey">
                      <button class="circle-more" @click="getComments">
                        <svg viewBox="0 0 18 18">
                            <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                              <rect
                                id="Rectángulo_redondeado_903"
                                data-name="Rectángulo redondeado 903"
                                width="2"
                                height="18"
                                rx="1"
                                transform="translate(179 753)"
                                fill="#fff"
                              />
                              <rect
                                id="Rectángulo_redondeado_903_copia"
                                data-name="Rectángulo redondeado 903 copia"
                                width="18"
                                height="2"
                                rx="1"
                                transform="translate(171 761)"
                                fill="#fff"
                              />
                            </g>
                          </svg>
                        </button>
                        </div>
                      <!-- END BUTTON CIRCLE -->
        
                  </div>

                </div>
            </div><!-- comments -->
            <div class="page-actions"> 
                <button class="button small outline" v-if="from2" @click="goBack">Regresar</button>
            </div>
        </div><!-- div w80-->
      </div>
    </section>
</template>

<script>

import moment from 'moment-timezone'
import { strings } from "@/services/strings.js";

export default {
    props:['item','comments','from','fromParams'],
    mixins: [strings],
    data () {
        return {
            url : this.$store.getters.getMainUrl,
            stars:['star','star','star','star'],
            defaultImg:this.$store.state.defaultNote,
            from2:null,
            noStars:0,
            like:false,
            dislike:false,
            meh:false,
            LastEvaluatedKey:null,
            defaultImage:this.$store.state.defaultNote
        }
    },
    beforeMount(){
        var backData2 = this.$store.state.backData2;
        var d = backData2.length>0? backData2[backData2.length-1]: {};
        this.from2 = d.from;
        this.fromParams = d.fromParams;
        this.extraParams = d.extraParams;
       if (this.item.metadatos) {
        var new_item = this.item.metadatos;
        if(new_item.titulo){
          this.$nextTick(function() {
            this.$set(this.item, "titulo", new_item.titulo);
          });
        }

        if(new_item.descripcion){
          this.$nextTick(function() {
            this.$set(this.item, "descripcion", new_item.descripcion);
          });
        }
        this.noStars = new_item.stars ? new_item.stars : this.noStars;
        this.setLikes(new_item.lke);
        
        this.setStars(this.noStars);
      }
    },
    methods:{
        
       
        setStars(noStars){
            this.noStars = noStars==undefined? this.noStars :noStars;
            this.pintaStars(noStars);
        },
        pintaStars(noStars){
            if(noStars!=undefined){
                this.resetStars();
                for(var i=0;i<noStars;i++){
                    this.stars[i] += ' active';
                }
            }
        },
        resetStars(){
            this.stars = ['star','star','star','star'];
        },
        setLike() {
            this.like = true;
            this.dislike = false;
            this.meh = false;
        },
        setDislike() {
            this.like = false;
            this.dislike = true;
            this.meh = false;
        },
        setMeh(){
            this.like = false;
            this.dislike = false;
            this.meh = true;
        },
        setLikes(type){
            switch(type){
                case 0: this.setDislike(); break;
                case 1: this.setLike(); break; 
                case 2: this.setMeh(); break;
            }
        },
        getFecha(fecha){
            moment.tz.setDefault('America/Mexico_City');
            var  tmp =  moment(fecha);
            var f = moment.tz(tmp,'America/Mexico_City').format('DD-MM-YYYY HH:mm:ss');
            return f;
        },
        goBack(){
             var backData2 = this.$store.state.backData2;
           
            var data = backData2.pop();
    
            if(data == undefined) {
                this.$router.back();
            }
            else{
              
                var from = data.from;
                var params = data.fromParams;
              if(from == 'publicNotas'){
                  this.$router.back();
              }else{
                this.$router.push({
                    name:from,
                    params:params
                });
              }
            }
        }
    }
}
</script>

<style scoped>

.sub{
    color:#00B99E;
}

</style>